import { z } from 'zod'

export const GetLoadFlagTypeSchema = z.object({
  description: z.string().nullish(),
  id: z.number(),
  is_active: z.boolean(),
  name: z.string(),
  slug: z.string(),
})

export const GetLoadFlagSchema = z.object({
  created_at: z.coerce.date(),
  flag_type_id: z.number(),
  id: z.number(),
  load_id: z.number(),
  notes: z.string().nullish(),
  updated_at: z.coerce.date().nullish(),
  user_id: z.number().nullish(),
})
